import {
  IconProps,
  IconType,
  IcoStarsStateChurned,
  IcoStarsStateNever,
  IcoStarsStateNone,
  IcoStarsStateRetained,
  IcoStarsStateTried,
} from "@/common/components/Icons";
import { FunnelState } from "@reflag/shared/featureAPI";

type State = FunnelState | "none";

const ICONS: Record<State, IconType> = {
  none: IcoStarsStateNone,
  never: IcoStarsStateNever,
  tried: IcoStarsStateTried,
  retained: IcoStarsStateRetained,
  churned: IcoStarsStateChurned,
};

type Props = IconProps & { state: State };

export default function StarsStateIcon({ state, ...props }: Props) {
  const Icon = ICONS[state];
  return <Icon {...props} />;
}
